import React from 'react';
import './TFSLoader.css';

const TFSLoader = () => (
  <div className="tfs-loader-container">
    <svg width="180" height="60" viewBox="0 0 180 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Road */}
      <rect y="45" width="180" height="8" rx="4" fill="#e5e7eb" />
      {/* Truck body */}
      <rect className="truck-body" x="40" y="25" width="60" height="20" rx="3" fill="#2563eb" />
      {/* TFS Logo (stylized text) */}
      <text x="55" y="40" fontFamily="Arial Black, Arial, sans-serif" fontSize="10" fill="#fff">TFS</text>
      {/* Truck cabin */}
      <rect className="truck-cabin" x="30" y="30" width="18" height="15" rx="2" fill="#ef4444" />
      {/* Window */}
      <rect x="33" y="33" width="7" height="7" rx="1" fill="#fff" />
      {/* Wheels */}
      <circle className="truck-wheel wheel1" cx="45" cy="48" r="4" fill="#374151" />
      <circle className="truck-wheel wheel2" cx="90" cy="48" r="4" fill="#374151" />
      {/* Animated packages */}
      <rect className="package package1" x="10" y="35" width="10" height="10" rx="2" fill="#fbbf24" />
      <rect className="package package2" x="-10" y="35" width="10" height="10" rx="2" fill="#fbbf24" />
    </svg>
    <div className="tfs-loader-text">Loading ... </div>
  </div>
);

export default TFSLoader; 